import type { NetSuiteSyncInvoicesSalesOrderRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';
import { toast } from 'react-toastify';

async function syncInvoiceToSalesOrder(
  netSuiteSyncInvoicesSalesOrderRequest: NetSuiteSyncInvoicesSalesOrderRequestPayload,
) {
  const api = getPrivateApi();

  return api.netSuiteSyncInvoicesSalesOrder({
    netSuiteSyncInvoicesSalesOrderRequest,
  });
}

export function useSyncNetSuiteInvoiceSalesOrder(
  options?: UseMutationOptions<void, unknown, NetSuiteSyncInvoicesSalesOrderRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: syncInvoiceToSalesOrder,
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.jobs());
    },
    onError: () => {
      toast.error(
        'Failed to export invoice as sales order',
        { position: 'bottom-left' },
      );
    },
    ...options,
  });
}
